<template>
  <div class="system-setting">
    <el-card class="setting-card">
      <div slot="header" class="clearfix">
        <span class="setting-title">系统设置</span>
      </div>

      <el-tabs>
        <!-- 修改密码 Tab -->
        <el-tab-pane label="修改密码">
          <div class="tab-content">
            <el-form :model="passwordForm" ref="passwordFormRef" :rules="rules" label-width="120px">
              <el-form-item label="原密码" prop="oldPassword">
                <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码"></el-input>
              </el-form-item>

              <el-form-item label="新密码" prop="newPassword">
                <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码（至少6位）"></el-input>
              </el-form-item>

              <el-form-item label="确认新密码" prop="confirmPassword">
                <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" :loading="isChangingPassword" @click="submitPasswordChange">保存新密码</el-button>
                <el-button @click="resetPasswordForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 账户注销 Tab -->
        <el-tab-pane label="账户注销">
          <div class="tab-content">
            <el-alert
              type="warning"
              title="注意"
              description="账户注销后将无法恢复，所有账户数据（包括记事、物品、日志等）都将被永久删除。请谨慎操作。"
              closable
              style="margin-bottom: 20px">
            </el-alert>

            <el-form label-width="120px">
              <el-form-item>
                <el-button type="danger" :loading="isLogoffing" @click="handleLogoff">注销账户</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import MD5 from 'crypto-js/md5'
import { changePassword, logoff } from '@/api/system'
import { mapActions } from 'vuex'

export default {
  name: 'SystemSetting',
  data() {
    const validatePasswordMatch = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认新密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      isChangingPassword: false,
      isLogoffing: false,
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码不少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validatePasswordMatch, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions('user', ['logout']),

    submitPasswordChange() {
      this.$refs.passwordFormRef.validate(async valid => {
        if (!valid) return
        try {
          this.isChangingPassword = true
          const res = await changePassword({
            oldPassword: MD5(this.passwordForm.oldPassword.trim()).toString(),
            newPassword: MD5(this.passwordForm.newPassword.trim()).toString()
          })

          if (res && res.data && res.data.code === 200) {
            this.$message.success('密码修改成功，请重新登录')
            // 修改成功后自动登出
            setTimeout(() => {
              this.logout()
              this.$router.replace('/login')
            }, 1500)
          } else {
            this.$message.error((res && res.data && res.data.msg) || '修改密码失败')
          }
        } catch (e) {
          const msg = e?.response?.data?.msg || e?.message || '修改密码异常'
          this.$message.error(msg)
        } finally {
          this.isChangingPassword = false
        }
      })
    },

    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.$refs.passwordFormRef.resetFields()
    },

    async handleLogoff() {
      try {
        await this.$confirm('账户注销会清空所有的账户数据，确定要注销吗？', '提示', {
          confirmButtonText: '确定注销',
          cancelButtonText: '取消',
          type: 'warning',
          modal: true
        })

        this.isLogoffing = true
        const res = await logoff({})

        if (res && res.data && res.data.code === 200) {
          this.$message.success('账户已注销')
          // 注销成功后自动登出并跳转登录页
          setTimeout(() => {
            this.logout()
            this.$router.replace('/login')
          }, 1500)
        } else {
          this.$message.error((res && res.data && res.data.msg) || '账户注销失败')
        }
      } catch (e) {
        if (e === 'cancel') return
        const msg = e?.response?.data?.msg || e?.message || '账户注销异常'
        this.$message.error(msg)
      } finally {
        this.isLogoffing = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.system-setting {
  .setting-card {
    max-width: 700px;
    margin: 0 auto;

    .setting-title {
      font-size: 18px;
      font-weight: bold;
      color: #2c3e50;
    }
  }

  .tab-content {
    padding: 20px 0;
  }
}
</style>
